"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYMENT_METHODS = {
    CARD: "direct credit card",
    PAYPAL: "paypal",
    APPLE: "apple pay",
};
var PAYMENT_METHODS_LABELS = {
    CARD: "Card",
    PAYPAL: "PayPal Account",
    APPLE: "Apple Pay",
};
var getCardPaymentMethod = function (method) {
    var cardInfo = method.CardInfoMessage;
    return __assign({ label: method.label, type: exports.PAYMENT_METHODS.CARD, paymentmethodInfo: {
            label: "Card",
            cardInfoMsg: { paymentMethodId: cardInfo.paymentMethodId },
        } }, cardInfo);
};
var getPaypalPaymentMethod = function (method) {
    var paypalInfo = method.PayPalAccountMessage;
    return __assign({ label: method.label, type: exports.PAYMENT_METHODS.CARD, paymentmethodInfo: {
            label: "PayPalAccount",
            paypalAccountMsg: { paymentMethodId: paypalInfo.paymentMethodId },
        } }, paypalInfo);
};
var getApplePaymentMethod = function (method) {
    var appleInfo = method.ApplePayInfoMessage;
    return __assign({ label: method.label, type: exports.PAYMENT_METHODS.CARD, paymentmethodInfo: {
            label: "ApplePay",
            cardInfoMsg: { paymentMethodId: appleInfo.paymentMethodId },
        } }, appleInfo);
};
var parsePaymentMethodByLabel = function (method) {
    switch (method.label) {
        case PAYMENT_METHODS_LABELS.CARD:
            return getCardPaymentMethod(method);
        case PAYMENT_METHODS_LABELS.PAYPAL:
            return getPaypalPaymentMethod(method);
        case PAYMENT_METHODS_LABELS.APPLE:
            return getApplePaymentMethod(method);
    }
};
function parsePaymentMethods(_a) {
    var _b = _a.PaymentMethods, PaymentMethods = _b === void 0 ? [] : _b;
    var labels = Object.values(PAYMENT_METHODS_LABELS);
    var pms = PaymentMethods.filter(function (_a) {
        var _b = _a.status, status = _b === void 0 ? "" : _b, _c = _a.isAutoPayment, isAutoPayment = _c === void 0 ? false : _c;
        return status === "Active" && isAutoPayment;
    }).filter(function (_a) {
        var _b = _a.label, label = _b === void 0 ? "" : _b;
        return labels.includes(label);
    });
    var paymentMethods = pms.map(parsePaymentMethodByLabel);
    var hasPaymentMethods = paymentMethods.length > 0;
    var methods = hasPaymentMethods ? paymentMethods : [];
    return {
        methods: methods,
        hasPaymentMethods: hasPaymentMethods,
    };
}
exports.parsePaymentMethods = parsePaymentMethods;
//# sourceMappingURL=PaymentMethods.js.map